import { useQuery } from "@tanstack/react-query";
import fetcher from "./fetcher";

function useCustomFetchQuery(key, url, token, options = {}) {
  return useQuery(key, () => fetcher(url, token), options);
}
export default useCustomFetchQuery;
